import { render, staticRenderFns } from "./Expansionllist.vue?vue&type=template&id=3ff0590f&scoped=true"
import script from "./Expansionllist.vue?vue&type=script&lang=js"
export * from "./Expansionllist.vue?vue&type=script&lang=js"
import style0 from "./Expansionllist.vue?vue&type=style&index=0&id=3ff0590f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0590f",
  null
  
)

export default component.exports